import { render, staticRenderFns } from "./rateio.vue?vue&type=template&id=7f495d12&"
import script from "./rateio.vue?vue&type=script&lang=js&"
export * from "./rateio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports